import * as React from 'react';

import { Link } from '~/UI/Button';

import styles from './styles.less';

const Logo = () => {
	return (
		<h1 className={styles.logo}>
			<Link styles={styles} to='/'>
				<strong className={styles.logoTitle}>Price Monitor</strong>
				<span className={styles.logoSubTitle}>COGVIO</span>
			</Link>
		</h1>
	);
};

export default React.memo(Logo);
